import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Column } from '@miq/catalog';
import { MiqBehaviors } from '@shared/behaviors';
import { getLovValueKey } from '@shared/utils/helpers/lov-datakey-factory';

import { SelectItem } from 'primeng/api';
import { BaseInput } from '../base-input';

@Component({
  selector: 'miq-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss'],
  providers: [{ provide: MiqBehaviors, useExisting: MultiSelectDropdownComponent }],
  standalone: false,
})
export class MultiSelectDropdownComponent extends BaseInput implements OnInit, OnChanges, OnDestroy {
  @Input() values: any;
  @Input() placeholder = '';
  @Input() lookupCategory: string;
  protected _config: Column;
  @Input()
  set config(c: Column) {
    this._config = c;
  }
  @Input() panelClass: boolean;
  @Input() isCloneRecord: boolean;

  @Output() currentValueChange = new EventEmitter<string[]>();

  dataKey = 'name';
  dropdownOptions: any = [];

  ngOnInit(): void {
    super.ngOnInit();
    this.generateOptions();
    this.dataKey = getLovValueKey(this.column);
  }

  ngOnChanges({ currentValue, ...changes }: SimpleChanges) {
    super.ngOnChanges(changes);
    if (!!currentValue && !currentValue.firstChange) {
      this.fc.setValue(this.currentValue);
    }
  }

  private generateOptions() {
    const dataKey = getLovValueKey(this.column);
    this.dropdownOptions = this.values
      .filter(i => !!i[dataKey])
      .map(i => ({ ...i, value: i.value.toUpperCase() }))
      .map(
        val =>
          ({
            label: val.value,
            value: val[dataKey],
            disabled: val.disabled && !this.isCloneRecord,
          }) as any as SelectItem
      );
  }

  public onChange(event) {
    this.currentValue = event.value;
    this.currentValueChange.emit(this.valueSetter ? this.valueSetter(event.value) : event.value);
  }

  ngOnDestroy() {
    /* label translation purpose added */
  }
}
